import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import renderImage from '../../../source/importImg'
import style from './ViewActions.module.css'
import unicodeToChar from '../../../utils/unicodeToChar'
import humanoid from '../../../Assets/images/ZingImage.png'
import { readBytes, sendBytes } from '../../ReusableComponents/ByteTransfer'
import {
    MSBLSBToDecimal,
    actionConverter,
} from '../../ReusableComponents/ByteTransfer/utils'
import ActionLoader from './ActionLoader'

import {
    bytesToActions,
    convertFileArrFormat,
    getListFile,
    getMountPoint,
    readsFile,
    removeFile,
} from '../../../utils/readWriteFile'
import { useIndexedDB } from 'react-indexed-db'

const INITIAL_FEEDBACK = {
    isOn: false,
    msg: '',
}

const trashIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        className="bi bi-trash"
        viewBox="0 0 16 16"
    >
        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
        <path
            fillRule="evenodd"
            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
        />
    </svg>
)
const ViewActions = (props) => {
    const history = useHistory()
    const [feedback, setFeedback] = useState(INITIAL_FEEDBACK)
    const [isHovered, setIsHovered] = useState(null)
    const [savedActions, setSavedActions] = useState([])
    const [saveActionList, setSaveActionList] = useState([])
    const [deleteFname, seteDeleteFname] = useState('')
    const [frLoader, setFrLoader] = useState(false)
    const [loader, setLoader] = useState(false)
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const { add, clear } = useIndexedDB('AudioFiles')

    const waitTimeRef = useRef(null)
    const useRefExtensionsReadRef = useRef({
        commendSend: false,
        commend: '',
        response: '',
        isError: false,
    })

    const timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            waitTimeRef.current = setTimeout(() => {
                return reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    const checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                // if (!JSON.parse(sessionStorage.getItem('sendDataAsPacket'))) {
                //     return resolve()
                // }
                if (!useRefExtensionsReadRef.current.commendSend) {
                    // clearTimeout(waitTimeRef.current)
                    // waitTimeRef.current = null
                    return resolve()
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    const setSdCardMountPoint = async () => {
        let sdCardMountAt = await getMountPoint({
            socket: props.socketData.socket,
        })
        props.deviceMismatch({
            ...props.device,
            plodeNativeData: {
                ...props.device.plodeNativeData,
                mountPoint: sdCardMountAt,
            },
        })
        return sdCardMountAt
    }

    useEffect(async () => {
        if (props.viewPopUp) {
            if (JSON.parse(sessionStorage.getItem('isShowNewUI') || 'false')) {
                try {
                    setFrLoader(true)
                    let sdCardMountAt =
                        props?.device?.plodeNativeData?.mountPoint
                    if (!sdCardMountAt) {
                        sdCardMountAt = await setSdCardMountPoint()
                    }
                    // sessionStorage.getItem('sdCardMountAt') || 'NO NAME'
                    let device = 'ZING'
                    if (connectedDevice === 'Hexapod') device = 'hexapod'

                    let filePath = `${sdCardMountAt}/${device}/actions/user/`

                    //get the Lists all files in a directory on the mounted USB device.
                    let listResponse = await getListFile({
                        socket: props.socketData.socket,
                        filePath: filePath,
                    })

                    setFrLoader(false)
                    if (listResponse.success) {
                        const { fileArray } = convertFileArrFormat(listResponse)
                        setSavedActions(fileArray)
                    } else {
                        setFeedback({
                            isOn: true,
                            msg: `'Action group can not open try again .....'`,
                        })
                    }
                    // let extenctionCommend = `list --path "/Volumes/${sdCardMountAt}/${device}/actions/user/"`
                    // let extenctionCommend = `list --path "/Volumes/ZING/` //${device}/action/user/"`
                    // Send message in extensions open the file list
                    // window.postMessage(
                    //     { type: 'sendMessage', data: extenctionCommend },
                    //     '*'
                    // )
                    // useRefExtensionsReadRef.current = {
                    //     commendSend: true,
                    //     commend: 'getFileList',
                    //     response: [],
                    //     isError: false,
                    // }
                    // let replyOK = await Promise.race([
                    //     checkOk(),
                    //     timeoutPromise(60000),
                    // ])
                    // if (useRefExtensionsReadRef.current.isError) {
                    //     setFrLoader(false)
                    // }
                    // useRefExtensionsReadRef.current = {
                    //     commendSend: false,
                    //     commend: '',
                    //     response: '',
                    //     isError: false,
                    // }
                } catch (e) {
                    setFrLoader(false)
                    console.error(e)
                }
            } else if (
                ['1', '2', '3'].includes(deviceVersion[0]) &&
                props.webSerial.isConnected
            ) {
                setFrLoader(true)
                props.worker.postMessage({
                    type: 'fetchFileWriteArray',
                    value: ['F'.charCodeAt(0), 'R'.charCodeAt(0)],
                })
                // sessionStorage.setItem('sendDataAsPacket', 'true')
                useRefExtensionsReadRef.current = {
                    commendSend: true,
                    commend: 'FR',
                    response: '',
                    isError: false,
                }
                try {
                    let replyOK = await Promise.race([
                        checkOk(),
                        timeoutPromise(10000), //
                    ])
                } catch (e) {
                    setFrLoader(false)
                }
            } else {
                if (props.webSerial.isConnected) fetchActionSlotData()
                useRefExtensionsReadRef.current = {
                    commendSend: false,
                    commend: '',
                    response: '',
                    isError: false,
                }
            }
        }
    }, [props.viewPopUp])

    useEffect(() => {
        const id = setTimeout(() => {
            setFeedback({ isOn: false })
        }, 3000)
        return () => clearTimeout(id)
    }, [feedback])

    const handleMouseEnter = (id) => {
        setIsHovered(id)
    }

    const handleMouseLeave = () => {
        setIsHovered(null)
    }

    const fetchActionSlotData = async () => {
        if (props.webSerial.port) {
            await sendBytes(
                ['F'.charCodeAt(0), 'R'.charCodeAt(0)],
                props.webSerial.port
            )
            let reader = props.webSerial.port.readable.getReader()
            let actionsList = ''
            while (true) {
                const { value } = await Promise.race([
                    reader.read(),
                    new Promise((_, reject) =>
                        setTimeout(reject, 2000, new Error('timeout'))
                    ),
                ])
                const result = unicodeToChar(value).trim()
                actionsList += result
                if (actionsList.slice(-3) === 'END') {
                    actionsList = actionsList.slice(0, -3)
                    reader.releaseLock()
                    break
                }
            }
            actionsList = actionsList
                .replace(/.BIN/g, ',')
                .split(',')
                .map((item) => item.trim())
            setSavedActions(actionsList.slice(0, -1))
        }
    }

    const deleteAction = async (name) => {
        let delAc = ['D'.charCodeAt(0), 'F'.charCodeAt(0), name.length]
        let fNameAsci = `${name}`.split('').map((item) => item.charCodeAt(0))

        seteDeleteFname(name)
        delAc = [...delAc, ...fNameAsci]
        if (JSON.parse(sessionStorage.getItem('isShowNewUI') || 'false')) {
            try {
                setLoader(true)
                let sdCardMountAt = props?.device?.plodeNativeData?.mountPoint
                if (!sdCardMountAt) {
                    sdCardMountAt = await setSdCardMountPoint()
                }
                // sessionStorage.getItem('sdCardMountAt') || 'NO NAME'
                let device = 'ZING'
                if (connectedDevice === 'Hexapod') device = 'hexapod'

                let filePath = `${sdCardMountAt}/${device}/actions/user/${name}`
                let removeResponse = await removeFile({
                    socket: props.socketData.socket,
                    filePath: filePath + '.bin',
                })
                // let extenctionCommend = `rm --name "${name}"`
                // let extenctionCommend = `rm --path "/Volumes/${sdCardMountAt}/${device}/actions/user/${name}"`
                // Send message in extensions delete the file
                // window.postMessage(
                //     { type: 'sendMessage', data: extenctionCommend },
                //     '*'
                // )
                // useRefExtensionsReadRef.current = {
                //     commendSend: true,
                //     commend: 'deleteFile',
                //     response: '',
                //     isError: false,
                // }
                // let replyOK = await Promise.race([
                //     checkOk(),
                //     timeoutPromise(60000),
                // ])

                // if (useRefExtensionsReadRef.current.isError) {
                //     setFeedback({
                //         isOn: true,
                //         msg: `Action group not deleted try again .....`,
                //     })
                // } else {
                //     setFeedback({
                //         isOn: true,
                //         msg: `Action group deleted.`,
                //     })

                //     const index = savedActions.indexOf(name)
                //     let newSavedActions = [...savedActions]
                //     if (index !== -1) {
                //         newSavedActions.splice(index, 1)
                //     }
                //     setSavedActions(newSavedActions)
                // }

                if (!removeResponse.success) {
                    setLoader(false)
                    setFeedback({
                        isOn: true,
                        msg: `Action group not deleted try again .....`,
                    })
                    return
                }
                let removeResponseAudio = await removeFile({
                    socket: props.socketData.socket,
                    filePath: filePath + '.mp3',
                })

                setLoader(false)
                setFeedback({
                    isOn: true,
                    msg: `Action group deleted.`,
                })

                const index = savedActions.indexOf(name)
                let newSavedActions = [...savedActions]
                if (index !== -1) {
                    newSavedActions.splice(index, 1)
                }
                setSavedActions(newSavedActions)
            } catch (e) {
                setLoader(false)
                console.error(e)
            } finally {
                setLoader(false)
                // useRefExtensionsReadRef.current = {
                //     commendSend: false,
                //     commend: '',
                //     response: '',
                //     isError: false,
                // }
            }
        } else if (['1', '2', '3'].includes(deviceVersion[0])) {
            setLoader(true)
            props.worker.postMessage({
                type: 'writeArray',
                value: delAc,
            })
            // sessionStorage.setItem('sendDataAsPacket', 'true')
            useRefExtensionsReadRef.current = {
                commendSend: true,
                commend: 'deleteAction',
                response: '',
                isError: false,
            }
            try {
                let replyOK = await Promise.race([
                    checkOk(),
                    timeoutPromise(1000), //
                ])
            } catch (e) {
                setLoader(false)
                setFeedback({
                    isOn: true,
                    msg: `Action group not deleted try again .....`,
                })
            }
        } else {
            await sendBytes(delAc, props.webSerial.port)
            if (props.webSerial.port) {
                if (!props.webSerial.port.readable.locked) {
                    let reader = props.webSerial.port.readable.getReader()
                    const { value } = await Promise.race([
                        reader.read(),
                        new Promise((_, reject) =>
                            setTimeout(reject, 500, new Error('timeout'))
                        ),
                    ])
                    const result = unicodeToChar(value).trim()
                    if (result.includes('OK')) {
                        await sendBytes(
                            ['D'.charCodeAt(0), 'F'.charCodeAt(0)],
                            props.webSerial.port
                        )
                        const { value } = await Promise.race([
                            reader.read(),
                            new Promise((_, reject) =>
                                setTimeout(reject, 500, new Error('timeout'))
                            ),
                        ])
                        const result = unicodeToChar(value).trim()
                        console.log(result)
                        reader.releaseLock()
                        if (result === 'DEL') {
                            setFeedback({
                                isOn: true,
                                msg: `Action deleted successfully`,
                            })
                            setTimeout(() => {
                                fetchActionSlotData()
                            }, 100)
                        } else {
                            setFeedback({
                                isOn: true,
                                msg: 'Action group not deleted try again .....',
                            })
                        }
                    }
                }
            }
        }
    }

    // open the action from zing board
    const openAction = async (name) => {
        console.log(name)
        name = name.trim()
        // if (props.webSerial.isConnected) {
        let fOpenBytes = ['F'.charCodeAt(0), 'A'.charCodeAt(0), name.length]
        let fNameAsci = `${name}`.split('').map((item) => item.charCodeAt(0))

        fOpenBytes = [...fOpenBytes, ...fNameAsci]
        if (JSON.parse(sessionStorage.getItem('isShowNewUI') || 'false')) {
            try {
                name = name.replace(/\.[^.]+$/, '')
                setLoader(true)
                let sdCardMountAt = props?.device?.plodeNativeData?.mountPoint
                if (!sdCardMountAt) {
                    sdCardMountAt = await setSdCardMountPoint()
                }
                // sessionStorage.getItem('sdCardMountAt') || 'NO NAME'
                let device = 'ZING'
                if (connectedDevice === 'Hexapod') device = 'hexapod'

                let filePath = `${sdCardMountAt}/${device}/actions/user/${name}.bin`
                let binReadResponse = await readsFile({
                    socket: props.socketData.socket,
                    filePath: filePath,
                })
                // let extenctionActionCommend = `open --loc "/Volumes/NO NAME/${name}.BIN"`
                // let extenctionActionCommend = `open --loc "/Volumes/${sdCardMountAt}/${device}/actions/user/${name}.BIN"`
                // Send message in extensions delete the file
                // window.postMessage(
                //     { type: 'sendMessage', data: extenctionActionCommend },
                //     '*'
                // )
                // useRefExtensionsReadRef.current = {
                //     commendSend: true,
                //     commend: 'openFileAction',
                //     response: '',
                //     isError: false,
                // }
                // let replyOK1 = await Promise.race([
                //     checkOk(),
                //     timeoutPromise(60000),
                // ])

                // if (useRefExtensionsReadRef.current.isError) {
                //     setLoader(false)
                //     setFeedback({
                //         isOn: true,
                //         msg: `Action group can not open try again .....`,
                //     })
                //     return
                // }
                let newActionState = {}
                if (binReadResponse.success) {
                    const byteCharacters = atob(binReadResponse.output)
                    const byteArray = [...byteCharacters].map((char) =>
                        char.charCodeAt(0)
                    )

                    let { newActionsData, newActionDetails } =
                        bytesToActions(byteArray)
                    if (!newActionsData) {
                        return
                    }
                    if (!newActionsData?.projectName) {
                        newActionsData.projectName = name
                    }

                    if (props.setSelectedAction) {
                        props.setSelectedAction(0)
                        props.setCreateActionState(newActionsData)
                    } else {
                        newActionState = newActionsData
                        // sessionStorage.setItem(
                        //     'createActionState',
                        //     JSON.stringify(newActionsData)
                        // )

                        // history.push('/code/project/action/create')
                        // sessionStorage.setItem('actionFileOpen', 'true')
                    }
                    // props.setViewPopUp(false)

                    // }
                } else {
                    setLoader(false)
                    setFeedback({
                        isOn: true,
                        msg: `Action group can not open try again .....`,
                    })
                    return
                }

                // let extenctionMp3Commend = `open --loc "/Volumes/${sdCardMountAt}/${device}/actions/user/${name}.mp3"`
                // window.postMessage(
                //     { type: 'sendMessage', data: extenctionMp3Commend },
                //     '*'
                // )
                // useRefExtensionsReadRef.current = {
                //     commendSend: true,
                //     commend: 'openFileMp3',
                //     response: '',
                //     isError: false,
                // }
                // let replyOK = await Promise.race([
                //     checkOk(),
                //     timeoutPromise(60000),
                // ])
                let mp3FilePath = `${sdCardMountAt}/${device}/actions/user/${name}.mp3`
                let mp3ReadResponse = await readsFile({
                    socket: props.socketData.socket,
                    filePath: mp3FilePath,
                })
                await clear()
                if (mp3ReadResponse.success) {
                    const base64Data = `data:audio/mp3;base64,${mp3ReadResponse.output}`
                    if (props.setAudioFile) {
                        props.setAudioFile(base64Data)
                    }
                    // await clear()
                    const id = await add({
                        fileName: 'audio.mp3',
                        fileData: base64Data,
                    })
                } else {
                    if (props.setAudioFile) props.setAudioFile(null)
                    // setFeedback({
                    //     isOn: tlorue,
                    //     msg: `Action group can not open try again .....`,
                    // })
                    // return
                }
                if (!props.setSelectedAction) {
                    sessionStorage.setItem(
                        'createActionState',
                        JSON.stringify(newActionState)
                    )

                    history.push('/code/project/action/create')
                    sessionStorage.setItem('actionFileOpen', 'true')
                }
                setLoader(false)
                props.setViewPopUp(false)
            } catch (e) {
                console.error(e)
            } finally {
                setLoader(false)
            }
        } else if (
            ['1', '2', '3'].includes(deviceVersion[0]) &&
            props.webSerial.isConnected
        ) {
            setLoader(true)
            props.worker.postMessage({
                type: 'fetchFileWriteArray', // writeArray
                value: fOpenBytes,
            })
            // sessionStorage.setItem('sendDataAsPacket', 'true')
            useRefExtensionsReadRef.current = {
                commendSend: true,
                commend: 'openFile',
                response: '',
                isError: false,
            }
            try {
                let replyOK = await Promise.race([
                    checkOk(),
                    timeoutPromise(10000), //
                ])
            } catch (e) {
                setLoader(false)
                setFeedback({
                    isOn: true,
                    msg: `'Action group can not open try again .....'`,
                })
            }
        } else {
            // fetchActionSlotData()
        }
        // }
    }
    //set the n

    //read data from zing S3 board
    useEffect(() => {
        let fsLength = 0

        const messageHandler = (e) => {
            let val = e.data.value
            if (e.data.type === 'read') {
                //check "DEL" came back from board
                if (
                    e.data.value.includes('DFOK')
                    // !e.data.value.includes('.BIN')
                    // fsLength == 0
                ) {
                    // sessionStorage.setItem('sendDataAsPacket', 'false')
                    useRefExtensionsReadRef.current = {
                        commendSend: false,
                        commend: '',
                        response: '',
                        isError: false,
                    }
                    let newSavedActions = [...savedActions]
                    let indexDeleteFile = newSavedActions.indexOf(deleteFname)
                    if (indexDeleteFile !== -1) {
                        newSavedActions.splice(indexDeleteFile, 1)
                        setSavedActions(newSavedActions)
                    }
                    setLoader(false)
                    setFeedback({
                        isOn: true,
                        msg: `Action  deleted successfully`,
                    })
                    //check "ERR" came back from board if file not deleted
                } else if (
                    e.data.value.includes('ERR') &&
                    !e.data.value.includes('FAERR')
                    //!e.data.value.includes('.BIN') &&
                    // fsLength == 0 &&
                ) {
                    // sessionStorage.setItem('sendDataAsPacket', 'false')
                    useRefExtensionsReadRef.current = {
                        commendSend: false,
                        commend: '',
                        response: '',
                        isError: true,
                    }
                    setLoader(false)
                    setFeedback({
                        isOn: true,
                        msg: `'Action group not deleted try again .....'`,
                    })

                    //check "ERR" came back from board if file datas not fetch
                } else if (
                    e.data.value.includes('FAERR')
                    // !e.data.value.includes('.BIN')
                    // fsLength == 0
                ) {
                    // sessionStorage.setItem('sendDataAsPacket', 'false')
                    useRefExtensionsReadRef.current = {
                        commendSend: false,
                        commend: '',
                        response: '',
                        isError: true,
                    }
                    setLoader(false)
                    setFeedback({
                        isOn: true,
                        msg: `'Action group can not open try again .....'`,
                    })
                }
            }

            //here we take arrayData, and stringData both together from serial worker
            if (e.data.type === 'actionRead') {
                let { arrayData, stringData } = e.data.value

                //extract the data after "FR" and before "END"
                let regexEqu = /13,10,70,82,([^]*?),10,69,78,68/
                let match = arrayData.join(',').match(regexEqu)
                if (match) {
                    const matchArr = match[1].split(',')
                    fsLength = matchArr[0]
                    const extractStringData = unicodeToChar(matchArr)
                    let fileNameArr = extractStringData.split(/[\n]+/)
                    //in the fileNameArr remove the length of actions
                    fileNameArr.shift()
                    setSavedActions(fileNameArr)
                }

                //extract the data after "FA" and before "END"
                let regexEquFA = /13,10,70,65,([^]*?),10,69,78,68/
                let matchFA = arrayData.join(',').match(regexEquFA)
                //set the data of each file fetch from board   stringData.includes('FA') && !stringData.includes('FAER')
                if (matchFA) {
                    // sessionStorage.setItem('sendDataAsPacket', 'false')
                    useRefExtensionsReadRef.current = {
                        commendSend: false,
                        commend: '',
                        response: '',
                        isError: false,
                    }
                    setLoader(false)
                    const matchArr = matchFA[1].split(',')
                    let createActionState = actionConverter(matchArr)
                    createActionState.projectName = 'Name'
                    if (props.setSelectedAction) {
                        props.setSelectedAction(0)
                        props.setCreateActionState(createActionState)
                    } else {
                        sessionStorage.setItem(
                            'createActionState',
                            JSON.stringify(createActionState)
                        )
                        history.push('/code/project/action/select')
                    }
                    props.setViewPopUp(false)
                }
            }
        }

        // Listen for messages from the extension
        // const extensionsMessageHandler = async (event) => {
        //     try {
        //         console.log('9999999999999999', useRefExtensionsReadRef.current)
        //         if (event.data.type === 'response') {
        //             if (event.data.data === 'END') {
        //                 // useRefExtensionsReadRef.current.commendSend = false
        //                 // if (
        //                 //     Array.isArray(
        //                 //         useRefExtensionsReadRef.current.response
        //                 //     ) &&
        //                 //     useRefExtensionsReadRef.current.response.length > 0
        //                 // ) {
        //                 //     const filteredArr =
        //                 //         useRefExtensionsReadRef?.current?.response?.filter(
        //                 //             (item) => item !== 'NO NAME'
        //                 //         )
        //                 //     setSavedActions(filteredArr)
        //                 // }
        //             } else if (
        //                 [
        //                     'Device VID:0xb1b0 PID:0x8055 not found or not mounted',
        //                     'Invalid rm command format',
        //                     'Failed to create directory',
        //                 ].includes(event.data.data)
        //             ) {
        //                 // useRefExtensionsReadRef.current = {
        //                 //     ...useRefExtensionsReadRef.current,
        //                 //     isError: true,
        //                 //     response: event.data.data,
        //                 // }
        //             } else if (
        //                 ['deleteFile'].includes(
        //                     useRefExtensionsReadRef.current.commend
        //                 )
        //             ) {
        //                 // useRefExtensionsReadRef.current.response =
        //                 //     event.data.data
        //             } else if (
        //                 useRefExtensionsReadRef.current.commend ===
        //                 'openFileMp3'
        //             ) {
        //                 // const match =
        //                 //     event.data.data.match(/^File base64:\s*(.+)/)
        //                 // if (match) {
        //                 //     const byteCharacters = atob(match[1])
        //                 //     const byteArray = new Uint8Array(
        //                 //         [...byteCharacters].map((char) =>
        //                 //             char.charCodeAt(0)
        //                 //         )
        //                 //     )
        //                 //     const base64Data = `data:audio/mp3;base64,${match[1]}`
        //                 //     props.setAudioFile(base64Data)
        //                 //     await clear()
        //                 //     const id = await add({
        //                 //         fileName: 'audio.mp3',
        //                 //         fileData: base64Data,
        //                 //     })
        //                 // }
        //             } else if (
        //                 useRefExtensionsReadRef.current.commend ===
        //                 'openFileAction'
        //             ) {
        //                 // const match =
        //                 //     event.data.data.match(/^File base64:\s*(.+)/)
        //                 // if (match) {
        //                 //     const byteCharacters = atob(match[1])
        //                 //     const byteArray = [...byteCharacters].map((char) =>
        //                 //         char.charCodeAt(0)
        //                 //     )
        //                 //     let { newActionsData, newActionDetails } =
        //                 //         bytesToActions(byteArray)
        //                 //     if (!newActionsData) {
        //                 //         return
        //                 //     }
        //                 //     if (props.setSelectedAction) {
        //                 //         props.setSelectedAction(0)
        //                 //         props.setCreateActionState(newActionsData)
        //                 //     } else {
        //                 //         sessionStorage.setItem(
        //                 //             'createActionState',
        //                 //             JSON.stringify(newActionsData)
        //                 //         )
        //                 //         history.push('/code/project/action/select')
        //                 //     }
        //                 //     props.setViewPopUp(false)
        //                 // }
        //             } else {
        //                 const match = event.data.data.match(/\/([^/.][^/]*)$/)

        //                 if (match) {
        //                     useRefExtensionsReadRef.current.response = [
        //                         ...useRefExtensionsReadRef.current.response,
        //                         match[1],
        //                     ]
        //                 }
        //             }
        //         }
        //     } catch (e) {
        //         console.error(e)
        //     }
        // }

        // window.addEventListener('message', extensionsMessageHandler)
        props.worker.addEventListener('message', messageHandler)

        return () => {
            props.worker.removeEventListener('message', messageHandler)
            // window.removeEventListener('message', extensionsMessageHandler)
        }
    }, [deleteFname])

    return (
        <>
            {props.viewPopUp && (
                <>
                    <div className={style.container}>
                        <img
                            className={style.closeBtn}
                            src={renderImage('clos')}
                            onClick={() => {
                                props.setViewPopUp(false)
                                setSavedActions([])
                            }}
                        />
                        <div
                            className={style.box}
                            style={{
                                justifyContent:
                                    savedActions.length === 0 ? 'center' : null,
                                alignItems:
                                    savedActions.length === 0 ? 'center' : null,
                            }}
                        >
                            {loader && <ActionLoader />}{' '}
                            {savedActions.length !== 0 ? (
                                savedActions.map((value, index) => {
                                    return (
                                        <div
                                            className={style.containerImage}
                                            key={index}
                                        >
                                            <img
                                                className={style.circularImage}
                                                src={humanoid}
                                                onClick={() =>
                                                    openAction(value)
                                                }
                                            />
                                            <div
                                                className={style.textContainer}
                                            >
                                                <div
                                                    className={
                                                        style.centeredText
                                                    }
                                                    onMouseEnter={() =>
                                                        handleMouseEnter(index)
                                                    }
                                                    onMouseLeave={
                                                        handleMouseLeave
                                                    }
                                                    onClick={() =>
                                                        openAction(value)
                                                    }
                                                >
                                                    {value}
                                                    {isHovered === index ? (
                                                        <div
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                deleteAction(
                                                                    value
                                                                )
                                                            }}
                                                        >
                                                            {trashIcon}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            ) : (
                                <>
                                    {!props.isShowNewUI &&
                                    !props.webSerial.isConnected ? (
                                        <p>Please connect the Device</p>
                                    ) : frLoader ? (
                                        <div className={style.loader}>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    ) : (
                                        <p>
                                            We can not fetch files, please try
                                            again
                                        </p>
                                    )}

                                    {/* {!props.isShowNewUI &&
                                        (!props.webSerial.isConnected ? (
                                            <p>Please connect the Device</p>
                                        ) : frLoader ? (
                                            <div className={style.loader}>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                        ) : (
                                            <p>
                                                We can not fetch files, please
                                                try again
                                            </p>
                                        ))} */}
                                </>
                            )}
                        </div>
                        {feedback.isOn ? (
                            <p
                                style={{
                                    position: 'absolute',
                                    bottom: '8vh',
                                    zIndex: 95001,
                                }}
                            >
                                {feedback.msg}
                            </p>
                        ) : (
                            <></>
                        )}
                    </div>
                </>
            )}
        </>
    )
}
const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        deviceMismatch: (data) => {
            dispatch({ type: 'DEVICE_MISMATCH', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ViewActions)
